import { useState } from "react";
import ChannelTab from "../ChannelTab/ChannelTab"
import EnterContent from "../EnterContent/EnterContent"
import ScreenListContent from "../ScreenListContent/ScreenListContent";
import BanerDashboard from "../../BanerDashboard/BanerDarshboard";

function ContentChannel({ chooseContent, contentForDelete, contentForEdit }) {

    const [activeTab, setActiveTab] = useState(0)

    return (
        <>
            <BanerDashboard text="مدیریت کانال ها" />
            <ChannelTab
                activeTab={activeTab}
                chooseActiveTab={setActiveTab}
            />
            {activeTab === 0 ?
                <EnterContent />
                : activeTab === 1 ?
                    <ScreenListContent
                        chooseContent={chooseContent}
                        contentForDelete={contentForDelete}
                        contentForEdit={contentForEdit}
                    />
                    :
                    null
            }
        </>
    )
}
export default ContentChannel;